package org.gstechnovos.jexonplastech.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.coroutines.launch
import kotlinx.serialization.json.JsonPrimitive
import kotlinx.serialization.json.buildJsonObject
import org.gstechnovos.jexonplastech.models.Theme
import org.gstechnovos.jexonplastech.styles.InputStyle
import org.gstechnovos.jexonplastech.styles.MainButtonStyle
import org.gstechnovos.jexonplastech.util.Constants.LocalBreakpoint
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.events.EventListener
import org.w3c.fetch.RequestInit
import kotlin.js.json

@Composable
fun ContactForm() {

    val breakpoint = LocalBreakpoint.current

    val scope = rememberCoroutineScope()

    // 1. Create State Variables for your inputs
    var name by remember { mutableStateOf("") }
    var email by remember { mutableStateOf("") }
    var message by remember { mutableStateOf("") }

    // UI State for feedback (optional but recommended)
    var buttonText by remember { mutableStateOf("Submit") }
    var isSending by remember { mutableStateOf(false) }

    Form(
        attrs = Modifier
            // Handle the submit event manually
            .attrsModifier {
                // "ref" gives us direct access to the actual HTML Element
                ref { element ->
                    // Define the listener
                    val listener = EventListener { e ->
                        e.preventDefault() // Stop page reload

                        // --- YOUR SUBMIT LOGIC HERE ---
                        isSending = true
                        buttonText = "Sending..."

                        scope.launch {
                            // 3. Send data using standard JS Fetch
                            val formData = buildJsonObject {
                                put("name", JsonPrimitive(name))
                                put("E-Mail", JsonPrimitive(email))
                                put("message", JsonPrimitive(message))
                            }

                            try {
                                val response = window.fetch(
                                    "https://formspree.io/f/xovgorja", object : RequestInit {
                                        override var method: String? = "POST"
                                        override var body: dynamic = formData.toString()
                                        override var headers: dynamic = json(
                                            "Content-Type" to "application/json",
                                            "Accept" to "application/json"
                                        )
                                    }).await()

                                if (response.ok) {
                                    // 4. SUCCESS: Clear the form
                                    name = ""
                                    email = ""
                                    message = ""
                                    buttonText = "Sent"
                                    // Reset button text after 3 seconds
                                    window.setTimeout({ buttonText = "Submit" }, 3000)
                                } else {
                                    buttonText = "Error"
                                }
                            } catch (e: Exception) {
                                buttonText = "Error"
                            } finally {
                                isSending = false
                            }
                        }
                    }

                    // Attach the listener
                    element.addEventListener("submit", listener)

                    // Cleanup when the component is destroyed
                    onDispose {
                        element.removeEventListener("submit", listener)
                    }
                }
            }.toAttrs()
    ) {
        // --- NAME INPUT ---
        Label(attrs = Modifier.classNames("form-label").toAttrs(), forId = "inputName") {
            Text("Name")
        }
        Input(
            type = InputType.Text,
            attrs = InputStyle.toModifier().id("inputName").classNames("form-control").margin(bottom = 10.px)
                .width(if (breakpoint >= Breakpoint.MD) 500.px else 250.px).backgroundColor(Theme.LighterGray.rgb)
                .attrsModifier {
                    attr("placeholder", "Full Name")
                    attr("required", "true")
                }.toAttrs {
                    // 5. BINDING: Connect State <-> UI
                    value(name)
                    onInput { name = it.value }
                })

        // --- EMAIL INPUT ---
        Label(attrs = Modifier.classNames("form-label").toAttrs(), forId = "inputEmail") {
            Text("E-Mail")
        }
        Input(
            type = InputType.Text,
            attrs = InputStyle.toModifier().id("inputEmail").classNames("form-control").margin(bottom = 10.px)
                .width(if (breakpoint >= Breakpoint.MD) 500.px else 250.px).backgroundColor(Theme.LighterGray.rgb)
                .attrsModifier {
                    attr("placeholder", "E-Mail Address")
                    attr("required", "true")
                }.toAttrs {
                    value(email)
                    onInput { email = it.value }
                })

        // --- MESSAGE INPUT ---
        Label(attrs = Modifier.classNames("form-label").toAttrs(), forId = "inputMessage") {
            Text("Message")
        }
        TextArea(
            attrs = InputStyle.toModifier().id("inputMessage").classNames("form-control").margin(bottom = 20.px)
            .height(150.px).width(if (breakpoint >= Breakpoint.MD) 500.px else 250.px)
            .backgroundColor(Theme.LighterGray.rgb).attrsModifier {
                attr("placeholder", "Your message")
                attr("required", "true")
            }.toAttrs {
                value(message)
                onInput { message = it.value }
            })

        // --- SUBMIT BUTTON ---
        Box(
            modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center
        ) {
            Button(
                attrs = MainButtonStyle.toModifier().height(40.px).borderRadius(5.px)
                    .backgroundColor(if (isSending) Colors.Gray else Theme.Primary.rgb) // Visual feedback
                    .color(Colors.White).cursor(if (isSending) Cursor.Wait else Cursor.Pointer).toAttrs()
            ) {
                Text(buttonText)
            }
        }
    }
}